import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=4113ca37&scoped=true&"
import script from "./EmptyData.vue?vue&type=script&lang=js&"
export * from "./EmptyData.vue?vue&type=script&lang=js&"
import style0 from "./EmptyData.vue?vue&type=style&index=0&id=4113ca37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4113ca37",
  null
  
)

export default component.exports